import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const CUSTOMERS_API_URL =
  process.env.REACT_APP_CUSTOMERS_API_URL || buildApiUrl('/customers');

export async function fetchCustomers() {
  const response = await requestCustomerApi(CUSTOMERS_API_URL, {
    fallbackMessage: 'Unable to load customers right now.',
  });

  return response.json();
}

export async function createCustomer(payload) {
  const response = await requestCustomerApi(CUSTOMERS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save customer right now.',
  });

  return response.json();
}

export async function updateCustomerStatus(id, status) {
  const response = await requestCustomerApi(`${CUSTOMERS_API_URL}/${id}/status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ status }),
    fallbackMessage: 'Unable to update customer status right now.',
  });

  return response.json();
}

export async function updateCustomer(id, payload) {
  const response = await requestCustomerApi(`${CUSTOMERS_API_URL}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to update customer right now.',
  });

  return response.json();
}

export async function deleteCustomer(id) {
  const response = await requestCustomerApi(`${CUSTOMERS_API_URL}/${id}`, {
    method: 'DELETE',
    fallbackMessage: 'Unable to delete customer right now.',
  });

  return response.json();
}

async function requestCustomerApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
